<template>
  <div>
    <TitlePage :title="$t('bookings')"></TitlePage>

    <v-layout wrap>
      <h4>Conferma prenotazione Codice: {{this.$route.query.code}}</h4>
      <v-container class="text-center mt-3">
        <v-row>
          <v-alert border="top" color="red lighten-2" dark v-if="success == false">
            Riprova più tardi, adesso è troppo presto per confermare il tuo match
          </v-alert>
          <v-alert border="top" color="green lighten-2" dark v-if="success == true">
            Prenotazione confermata con successo
          </v-alert>
        </v-row>
      </v-container>
    </v-layout>

  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "BookingsComplete",
  components: {TitlePage},
  data() {
    return {
      success: null
    }
  },
  async created() {
    await this.confirmBooking()
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'complete': 'bookings/complete'
    }),

    async confirmBooking() {

      await this.setLoading(true);
      var result = await this.complete({code:this.$route.query.code})
      await this.setLoading(false);

      if (result.success) {

        this.success = true
        // this.setNotification({
        //   active: true,
        //   color: 'success',
        //   mode: 'multi-line',
        //   text: this.$t('updateSuccess')
        // })

        // this.$router.push('/bookings')

      } else {

        this.success = false

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Riprova più tardi, adesso è troppo presto per confermare il tuo match'
        })

      }


    },
  },
}
</script>

<style scoped>

</style>